<template>
  <div>
    <div class="modal-overlay" @click="closeLoadStateModal" v-if="open"></div>
    <div class="rates-modal-container" :class="[open ? 'open' : 'closed']">
      <h1>Load Saved Delivery</h1>
      <ul v-if="savedStates.length > 0">
        <li v-for="(state, index) in savedStates" :key="index">
          <span>{{ state.name }}</span>
          <div class="load-buttons">
            <button @click="loadISState(state)" class="btn btn-primary">
              Load
            </button>
            <button @click="deleteIsState(state)" class="btn">Delete</button>
          </div>
        </li>
      </ul>
      <div v-else>
        <p>No Saved Deliveries</p>
      </div>

      <button @click="closeLoadStateModal" class="btn cancel">Cancel</button>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {};
  },
  props: ['open', 'savedStates'],
  methods: {
    closeLoadStateModal() {
      this.$emit('toggleLoadShipmentModal');
    },
    loadISState(state) {
      this.$emit('loadShipment', state.id);
    },
    deleteIsState(state) {
      this.$emit('deleteShipment', state.id);
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background: rgba(0, 0, 0, 0.5);
}

td,
th {
  padding: 0.7rem;
}

tr {
  border-bottom: 1px solid black;
}

p {
  margin-top: 3rem;
}

ul {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  list-style: none;
  margin-top: 3rem;
}

.cancel {
  position: absolute;
  bottom: 2rem;
  right: 2rem;
}

li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 300px;
  margin: 1rem;
}
.open {
  opacity: 1;
  top: 50%;
  transition: 0.3s ease-in-out;
}

.closed {
  top: -100%;
  opacity: 0;
  transition: 0.3s ease-in-out;
}

.rates-modal-container {
  position: fixed;
  z-index: 3;
  left: 50%;
  height: 360px;
  width: 350px;
  text-align: center;
  background: white;
  margin-left: -175px;
  border-radius: 20px;
  margin-top: -180px;
  align-items: center;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

label {
  margin-bottom: 17px;
}

select {
  margin-bottom: 2rem;
}

h1 {
  padding: 0.5rem;
  font-size: 14px;
  margin-bottom: 15px;
  margin-top: -13px;
  width: 100%;
  background: lightgrey;
  border-bottom: 1px solid black;
  position: absolute;
  top: 12px;
}
</style>
